import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        salutation: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        password: null,
        errors: {},
        askPassword: true,
        packingStation: null,
        packingStationPostCode: null,
        fiscalCode: null,
        uid: null,
        company: null,
    },
    getters: {
        getSalutation: state => state.salutation,
        getFirstName: state => state.firstName,
        getLastName: state => state.lastName,
        getEmail: state => state.email,
        getPhone: state => state.phone,
        getCompany: state => state.company,
        getUid: state => state.uid,
        getPassword: state => state.password,
        getAskPassword: state => state.askPassword,
        getPackingStation: state => state.packingStation,
        getPackingStationPostCode: state => state.packingStationPostCode,
        getFiscalCode: state => state.fiscalCode,
    },
    mutations: {
        setSalutation(state, value) {
            state.salutation = value;
        },
        setFirstName(state, value) {
            state.firstName = value;
        },
        setLastName(state, value) {
            state.lastName = value;
        },
        setEmail(state, value) {
            state.email = value;
        },
        setPhone(state, value) {
            state.phone = value;
        },
        setCompany(state, value) {
            state.company = value;
        },
        setUid(state, value) {
            state.uid = value;
        },
        setPassword(state, value) {
            state.password = value;
        },
        setAskPassword(state, value) {
            state.askPassword = value;
        },
        setPackingStation(state, value) {
            state.packingStation = value;
        },
        setPackingStationPostCode(state, value) {
            state.packingStationPostCode = value;
        },
        setFiscalCode(state, value) {
            state.fiscalCode = value;
        },
        setErrors(state, errors) {
            for (let field of Object.keys(errors)) {
                Vue.set(state.errors, field, errors[field]);
            }
        },
        resetErrors(state, field) {
            if (field && state.errors[field]) {
                delete state.errors[field];
            } else {
                state.errors = {};
            }
        },
    },
};
